import {
    ActiveCompetitionSelector,
    LegalContestDeferFormPublishCompetitionIdSelector,
} from "shared/reducers/CompetitionActionPanel";
import { useSelector } from "react-redux";
import { ProjectAPI } from "@brg/api";
import { useToasts } from "@brg/ui";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import useCompetitionActions from "./useCompetitionActions";
import { useEffect } from "react";
import {
    PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID,
    TEAM_FORM_CONTINUE_COMPETITION_QUERY,
    TEAM_FORM_DEFER_APPLY_PROJECT_QUERY,
} from "_competition/const";

/** Публикация с панели конкурса: редирект на «отправить проект» только если бэкенд пометил оплату, иначе — анкета (студенты PaidWithForm). Юрлица с новым проектом — отдельно по Redux defer. */
const useCompetitionPanelActions = ({ projectId }: { projectId: string }) => {
    const activeCompetition = useSelector(ActiveCompetitionSelector);
    const deferLegalFormCompetitionId = useSelector(LegalContestDeferFormPublishCompetitionIdSelector);
    const toasts = useToasts();
    const history = useHistory();

    const { onApplyClick, setSelectedProjects, getLegalsModal, needToFillForm } =
        useCompetitionActions(activeCompetition);

    const isPaidContestFromApi = !!activeCompetition?.isPaidApplication;

    useEffect(() => {
        setSelectedProjects([projectId]);
    }, [projectId, setSelectedProjects]);

    const publishIfNeeded = async (
        pid: string,
        shouldPublish: boolean,
        makePrivate: boolean | undefined,
    ): Promise<boolean> => {
        if (!shouldPublish) {
            return true;
        }
        try {
            const r = await ProjectAPI.UpdateStatus({
                projectStatus: makePrivate ? 10 : 1,
                projectId: pid,
            });
            if (r?.status !== 200) {
                toasts.error('Не удалось опубликовать проект');
                return false;
            }
        } catch {
            toasts.error('Не удалось опубликовать проект');
            return false;
        }
        return true;
    };

    const sendProjectToCompetition = async ({
        projectId: pid,
        shouldPublish,
        makePrivate,
    }: { projectId: string; shouldPublish: boolean; makePrivate?: boolean }) => {
        if (!activeCompetition?.competitionId) {
            return;
        }

        const deferMatches =
            !!deferLegalFormCompetitionId &&
            deferLegalFormCompetitionId === activeCompetition.competitionId;

        if (deferMatches) {
            const ok = await publishIfNeeded(pid, shouldPublish, makePrivate);
            if (!ok) {
                return;
            }
            const teamFormQs = new URLSearchParams({
                [TEAM_FORM_CONTINUE_COMPETITION_QUERY]: activeCompetition.competitionId,
                [TEAM_FORM_DEFER_APPLY_PROJECT_QUERY]: pid,
            }).toString();
            history.push(`/teams/form/${PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID}?${teamFormQs}`);
            return;
        }

        if (isPaidContestFromApi) {
            const ok = await publishIfNeeded(pid, shouldPublish, makePrivate);
            if (!ok) {
                return;
            }
            const search = new URLSearchParams({
                openModal: 'send-project',
                selectedProjectId: pid,
                competitionId: activeCompetition.competitionId,
            }).toString();
            history.push(`${CreateLinkTo.project(pid)}?${search}`);
            return;
        }
        getLegalsModal(needToFillForm, () =>
            onApplyClick({
                shouldPublish,
                projectId: pid,
                makePrivate,
            }),
            pid ? [pid] : undefined,
        );
    };

    return {
        sendProjectToCompetition,
    };
};

export default useCompetitionPanelActions;import {
    ActiveCompetitionSelector,
    LegalContestDeferFormPublishCompetitionIdSelector,
} from "shared/reducers/CompetitionActionPanel";
import { useSelector } from "react-redux";
import { ProjectAPI } from "@brg/api";
import { useToasts } from "@brg/ui";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import useCompetitionActions from "./useCompetitionActions";
import { useEffect } from "react";
import {
    PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID,
    TEAM_FORM_CONTINUE_COMPETITION_QUERY,
    TEAM_FORM_DEFER_APPLY_PROJECT_QUERY,
} from "_competition/const";

/** Публикация с панели конкурса: редирект на «отправить проект» только если бэкенд пометил оплату, иначе — анкета (студенты PaidWithForm). Юрлица с новым проектом — отдельно по Redux defer. */
const useCompetitionPanelActions = ({ projectId }: { projectId: string }) => {
    const activeCompetition = useSelector(ActiveCompetitionSelector);
    const deferLegalFormCompetitionId = useSelector(LegalContestDeferFormPublishCompetitionIdSelector);
    const toasts = useToasts();
    const history = useHistory();

    const { onApplyClick, setSelectedProjects, getLegalsModal, needToFillForm } =
        useCompetitionActions(activeCompetition);

    const isPaidContestFromApi = !!activeCompetition?.isPaidApplication;

    useEffect(() => {
        setSelectedProjects([projectId]);
    }, [projectId, setSelectedProjects]);

    const publishIfNeeded = async (
        pid: string,
        shouldPublish: boolean,
        makePrivate: boolean | undefined,
    ): Promise<boolean> => {
        if (!shouldPublish) {
            return true;
        }
        try {
            const r = await ProjectAPI.UpdateStatus({
                projectStatus: makePrivate ? 10 : 1,
                projectId: pid,
            });
            if (r?.status !== 200) {
                toasts.error('Не удалось опубликовать проект');
                return false;
            }
        } catch {
            toasts.error('Не удалось опубликовать проект');
            return false;
        }
        return true;
    };

    const sendProjectToCompetition = async ({
        projectId: pid,
        shouldPublish,
        makePrivate,
    }: { projectId: string; shouldPublish: boolean; makePrivate?: boolean }) => {
        if (!activeCompetition?.competitionId) {
            return;
        }

        const deferMatches =
            !!deferLegalFormCompetitionId &&
            deferLegalFormCompetitionId === activeCompetition.competitionId;

        if (deferMatches) {
            const ok = await publishIfNeeded(pid, shouldPublish, makePrivate);
            if (!ok) {
                return;
            }
            const teamFormQs = new URLSearchParams({
                [TEAM_FORM_CONTINUE_COMPETITION_QUERY]: activeCompetition.competitionId,
                [TEAM_FORM_DEFER_APPLY_PROJECT_QUERY]: pid,
            }).toString();
            history.push(`/teams/form/${PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID}?${teamFormQs}`);
            return;
        }

        if (isPaidContestFromApi) {
            const ok = await publishIfNeeded(pid, shouldPublish, makePrivate);
            if (!ok) {
                return;
            }
            const search = new URLSearchParams({
                openModal: 'send-project',
                selectedProjectId: pid,
                competitionId: activeCompetition.competitionId,
            }).toString();
            history.push(`${CreateLinkTo.project(pid)}?${search}`);
            return;
        }
        getLegalsModal(needToFillForm, () =>
            onApplyClick({
                shouldPublish,
                projectId: pid,
                makePrivate,
            }),
            pid ? [pid] : undefined,
        );
    };

    return {
        sendProjectToCompetition,
    };
};

export default useCompetitionPanelActions;